module.exports = __webpack_public_path__ + "static/img/bottom-bg-02.0b5023d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/bottom-bg-02.png
// module id = wuLn
// module chunks = 1